<div
	class="p-2 rounded-lg bg-secondary-800 text-white"
	id="summary-of-the-year-single-vehicle-overview-year"
>
	<div class="flex flex-col items-center justify-center mx-6">
		<div class="text-4xl">{{ 'summary.summary_of_the_year' | translate }}</div>
		<div class="text-9xl font-bold">{{ year() }}</div>
	</div>
</div>
